/**
 * Amplitude client
 * This copies the amplitude client from the window object
 */

export const amplitudeClient = window.amplitude;
